var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "rbacActiveStatusModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body desc-text" }, [
            _c("div", { staticClass: "modal-title" }, [
              _vm.roleDetails.is_active
                ? _c("div", { staticClass: "title-text" }, [
                    _c("div", { staticClass: "align-lt" }, [
                      _vm._v(
                        "Are you sure you would like to deactivate this role?"
                      ),
                    ]),
                    _c("div", { staticClass: "role-name" }, [
                      _vm._v(" " + _vm._s(_vm.roleDetails.role_name)),
                    ]),
                  ])
                : _c("div", { staticClass: "title-text" }, [
                    _c("div", { staticClass: "align-lt" }, [
                      _vm._v(
                        "Are you sure you would like to activate this role?"
                      ),
                    ]),
                    _c("div", { staticClass: "role-name pt-10" }, [
                      _vm._v(" " + _vm._s(_vm.roleDetails.role_name)),
                    ]),
                  ]),
              _c("div", { staticClass: "col-xs-12 pt-10" }, [
                _vm.roleDetails.is_active
                  ? _c("div", { staticClass: "col-xs-11" }, [
                      _vm._v(
                        " By deactivating this role, you will lose all data that has been created for this role. "
                      ),
                    ])
                  : _c("div", { staticClass: "col-xs-11" }, [
                      _vm._v(
                        " By activating this role, you will again access to all saved data that has been previously created. "
                      ),
                    ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer deactiveModal-bgcolor" }, [
            _c("div", { staticClass: "col-sm-6 col-xs-12 mt-10" }, [
              _vm.roleDetails.is_active
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      on: { click: _vm.updateStatus },
                    },
                    [_vm._v("Yes, deactivate role")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      on: { click: _vm.updateStatus },
                    },
                    [_vm._v("Yes, activate role")]
                  ),
            ]),
            _vm._m(1),
          ]),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header deactiveModal-bgcolor" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#rbacActiveStatusModal",
          },
        },
        [_vm._v("×")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6 col-xs-12 mt-10" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-blue-button",
          attrs: {
            "data-toggle": "modal",
            "data-target": "#rbacActiveStatusModal",
          },
        },
        [_vm._v("No, keep role")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }